import { LogoMark, StarDoodle } from "./doodles";
import { scrollToSection } from "@/config/station";

const LINKS = [
    { id: "listen-live", label: "Listen Live" },
    { id: "show-love", label: "Show Some Love" },
    { id: "submit-music", label: "Submit Music" },
    { id: "home", label: "Back to Top" },
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t-[3px] border-sunny bg-ink py-12 text-cream sm:py-14"
        >
            <div className="mx-auto max-w-6xl px-4 sm:px-6">
                <div className="flex flex-col items-center gap-8 text-center">
                    <div className="flex items-center gap-3">
                        <LogoMark className="h-12 w-12" />
                        <div className="text-left leading-none">
                            <p className="font-mono2 text-[10px] font-bold uppercase tracking-[0.2em] text-cream/70">
                                MyRadio1st Presents
                            </p>
                            <p className="font-marker text-2xl text-sunny">Inspiration Station</p>
                        </div>
                    </div>

                    <p
                        data-testid="footer-tagline"
                        className="font-condensed text-2xl font-black uppercase tracking-tight text-cream sm:text-3xl"
                    >
                        Good Music. Good Energy.{" "}
                        <span className="text-sunny">No Gatekeeping.</span>
                    </p>

                    <nav className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2" aria-label="Footer">
                        {LINKS.map((l, i) => (
                            <span key={l.id} className="flex items-center gap-2">
                                <button
                                    data-testid={`footer-link-${l.id}`}
                                    onClick={() => scrollToSection(l.id)}
                                    className="rounded px-2 py-1 font-condensed text-base font-bold uppercase tracking-wide text-cream/85 transition-colors hover:text-sunny focus:outline-none focus-visible:ring-2 focus-visible:ring-sunny"
                                >
                                    {l.label}
                                </button>
                                {i < LINKS.length - 1 && <StarDoodle className="h-3 w-3" fill="#FFD026" />}
                            </span>
                        ))}
                    </nav>

                    <p className="font-mono2 text-xs text-cream/60">
                        © 2026 MyRadio1st Presents: Inspiration Station. Independent sound. Real community.
                    </p>
                </div>
            </div>
        </footer>
    );
}
